import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    VisibilityOptions,
    emptySelectedCommunities,
    setVisibility
} from "services/redux/feedForm/feedForm";
import { AppDispatch, RootState } from "services/redux/store";
import { SVG } from "ui";
import { GeneralModalProps } from "utils/types/generalTypes";
import SelectCommunitiesModal from "./SelectCommunitiesModal";

const EngajmentModal = ({ open, setOpen }: GeneralModalProps) => {
    const engajmentModalPosition = useSelector(
        (state: RootState) => state.feedForm.engajmentModalPosition
    );
    const dispatch = useDispatch<AppDispatch>();
    const changeVisibility = (val: VisibilityOptions) => {
        dispatch(setVisibility(val));
        dispatch(emptySelectedCommunities());
        setOpen(false);
    };

    const [openCommunityModal, setOpenCommunityModal] = useState(false);

    return (
        <>
            <div
                id="ingajment-modal"
                className={`modal has-light-bg ${open ? "is-active" : ""}`}
            >
                <div
                    className="modal-background"
                    onClick={() => setOpen(false)}
                ></div>
                <div
                    className="modal-content"
                    style={{
                        top: `${engajmentModalPosition.top}px`,
                        left: `${engajmentModalPosition.left}px`
                    }}
                >
                    <div className="card is-new-content">
                        <div className="card-heading flex-a-center">
                            <div>
                                <h3 className="momeento-p">
                                    Select who could see your post
                                </h3>
                            </div>

                            {/* <!-- Close X button --> */}
                            <div className="close-wrap">
                                <span
                                    className="custom-close-modal"
                                    onClick={() => setOpen(false)}
                                >
                                    <SVG svg="x" size={16} />
                                </span>
                            </div>
                        </div>

                        <div className="card-body">
                            <div className="control">
                                <div className="field">
                                    <div className="custom-select">
                                        <ul
                                            className="select-dropdown"
                                            role="listbox"
                                            id="select-dropdown"
                                        >
                                            <li role="option">
                                                <label
                                                    className="momeento-p d-flex flex-a-center gap-5"
                                                    onClick={() =>
                                                        changeVisibility(
                                                            "Everyone"
                                                        )
                                                    }
                                                >
                                                    <SVG
                                                        svg="globe"
                                                        size={16}
                                                    />
                                                    <span>Everyone</span>
                                                </label>
                                            </li>
                                            <li role="option">
                                                <label
                                                    htmlFor="people-you-follow"
                                                    className="momeento-p d-flex flex-a-center gap-5"
                                                    onClick={() =>
                                                        changeVisibility(
                                                            "People You Follow"
                                                        )
                                                    }
                                                >
                                                    <SVG
                                                        svg="user-check"
                                                        size={16}
                                                    />
                                                    <span>
                                                        People You Follow
                                                    </span>
                                                </label>
                                            </li>
                                            <li role="option">
                                                <label
                                                    htmlFor="community"
                                                    className="momeento-p d-flex flex-a-center gap-5"
                                                    onClick={() => {
                                                        setOpenCommunityModal(
                                                            true
                                                        );
                                                        setOpen(false);
                                                    }}
                                                >
                                                    <SVG
                                                        svg="community"
                                                        size={16}
                                                    />
                                                    <span>Community</span>
                                                </label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SelectCommunitiesModal
                open={openCommunityModal}
                setOpen={setOpenCommunityModal}
            />
        </>
    );
};

export default EngajmentModal;
